/* Born of Shadows: product thumbnails under the main image on phones.
   On mobile Yuva shows the big gallery as a native horizontal scroller and hides its thumbnail row
   (data-desktop-only). This turns that row on, makes it tap-to-jump, and keeps the active thumb in sync. */
(function () {
  var MQ = window.matchMedia('(max-width: 767px)');

  function visible(el) { return el && el.offsetParent !== null; }

  function setup(wrap) {
    if (wrap.__bosThumbs) return;
    var big = wrap.querySelector('.yv-product-big-slider');
    var box = wrap.querySelector('.yv-product-small-slider-container');
    if (!big || !box) return;
    var thumbs = box.querySelectorAll('.yv-product-slider-item[data-image]');
    if (thumbs.length < 2) return;
    wrap.__bosThumbs = true;
    var lockUntil = 0;
    box.classList.add('bos-mthumbs');

    thumbs.forEach(function (t) {
      var img = t.querySelector('img');
      if (img && !img.getAttribute('src')) {
        var src = img.getAttribute('data-src') || '';
        if (src) img.src = src.replace('{width}', '160');
        else if (img.getAttribute('data-original')) img.src = img.getAttribute('data-original') + '&width=160';
      }
      t.setAttribute('role', 'button');
      t.setAttribute('tabindex', '0');
      function go() {
        var id = t.getAttribute('data-image').replace('media-', '');
        var slide = big.querySelector('#media-main-' + id);
        if (!slide) return;
        big.scrollTo({ left: slide.offsetLeft - big.offsetLeft, behavior: 'smooth' });
        lockUntil = Date.now() + 700;
        mark(t, true);
      }
      t.addEventListener('click', go);
      t.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); go(); } });
    });

    function mark(t, animate) {
      thumbs.forEach(function (x) { x.classList.toggle('is-active', x === t); });
      var row = t.parentNode;
      var left = t.offsetLeft - row.offsetLeft - (row.clientWidth - t.offsetWidth) / 2;
      row.scrollTo({ left: left, behavior: animate ? 'smooth' : 'auto' });
    }

    var ticking = false;
    big.addEventListener('scroll', function () {
      if (ticking || Date.now() < lockUntil) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        var slides = [].filter.call(big.querySelectorAll('.big__slider'), visible);
        var x = big.scrollLeft, best = null, bestD = Infinity;
        slides.forEach(function (s) {
          var d = Math.abs((s.offsetLeft - big.offsetLeft) - x);
          if (d < bestD) { bestD = d; best = s; }
        });
        if (!best) return;
        var id = best.id.replace('media-main-', '');
        var t = box.querySelector('[data-image="media-' + id + '"]');
        if (t && !t.classList.contains('is-active')) mark(t, true);
      });
    }, { passive: true });

    mark(thumbs[0], false);
  }

  function init() {
    if (!MQ.matches) return;
    document.querySelectorAll('.product-detail-slider').forEach(setup);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  if (MQ.addEventListener) MQ.addEventListener('change', init);
})();
